import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Typography, List, Spin, Card, Button } from "antd";
import { DeleteOutlined, EditOutlined} from "@ant-design/icons";
import { trainingAPI } from "../../api/TrainingAPI";
import moment from "moment";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

const { Text } = Typography;

const Notes = ({ player, notes, updateNotes, handleEditNoteClick, handleDeleteClick }) => {
	const [notesLoading, setNotesLoading] = useState(true);
	const { user } = useAuth0();
	const email = user?.email

	useEffect(() => {
		const fetchNotes = async () => {
			setNotesLoading(true);
			try {
				const response = await trainingAPI.getPlayerNotes(player);
				if (response) updateNotes(response);
			} catch (error) {
				message.error("Failed to fetch notes");
			} finally {
				setNotesLoading(false);
			}
		};
		fetchNotes();
	}, [player, updateNotes]);

	return (
		<Spin spinning={notesLoading}>
			{notes && notes.length > 0 ? (
				<List
					dataSource={notes}
					renderItem={(item, index) =>
						item && (
							<Card
								style={{
									width: "100%",
									borderRadius: ".5rem",
									marginBottom: "1rem"
								}}
								className="profile-player-notes-card"
							>
								<List.Item
									key={item.player_notes_id || index}
									style={{
										width: "100%",
										padding: ".2rem",
										display: "flex",
										flexDirection: "column",
										alignItems: "start",
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "baseline",
											marginBottom: "0.5em",
											width: "100%",
											justifyContent: "space-between"
										}}
									>
										<Text
											strong
											style={{ marginRight: "5rem", textAlign:"left" }}
										>
											{item.author_name || ""}
										</Text>
										<Text
											style={{
												fontSize: "0.8em",
												textAlign:"left",
												color: "#888",
											}}
										>
											{moment(item.timestamp).format(
												"HH:mm · YYYY-MM-DD"
											) || ""}
										</Text>
									</div>
									<p
										style={{
											alignSelf: "flex-start",
											textAlign: "left",
											width: "100%",
											margin: 0,
											padding: 0,
										}}
									>
										{item.notes || ""}
									</p>
									<div
										style={{
											display: "flex",
											justifyContent: "flex-end",
											alignItems: "center",
											width: "100%",
											height: "30px",
										}}
									>
										<Button
											type="primary"
											shape="circle"
											ghost
											size="small"
											icon={<EditOutlined />}
											disabled={email !== item?.author_email}
											onClick={() => handleEditNoteClick(item?.player_notes_id, item?.notes)}
											aria-label="Edit note"
											style={{
												margin: "5px"
											}}
										/>
										<Button
											type="primary"
											shape="circle"
											danger ghost
											size="small"
											icon={<DeleteOutlined />}
											disabled={email !== item?.author_email}
											onClick={() => handleDeleteClick(item?.player_notes_id)}
											aria-label="Delete note"
										/>
									</div>
								</List.Item>{" "}
							</Card>
						)
					}
				/>
			) : (
				<div style={{ textAlign: "center", padding: "1.25rem" }}>
					{notesLoading ? "Loading notes..." : "No notes available"}
				</div>
			)}
		</Spin>
	);
};

export default Notes;
